<template>
  <div class="information">
    <van-nav-bar
      :title="title"
      class="main-nav"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
      <component :is="curCompon"></component>
    </div>
  </div>
</template>

<script>
import child from "./components/child.vue";
import major from "./components/major.vue";
export default {
  name: "",
  components: { child, major },
  data() {
    return {
      title: "儿童档案信息",
      curCompon: "child",
    };
  },
  computed: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  mounted() {
    let { registryType, isParent } = this.$route.query;
    if (registryType == 1 || (isParent && isParent == "1")) {
      this.curCompon = "child";
      this.title = "儿童档案信息";
    } else {
      this.curCompon = "major";
      this.title = "专业人士档案信息";
    }
  },
};
</script>
<style lang="less" scoped>
.information {
  /deep/.van-nav-bar {
    position: fixed;
    width: 100%;
  }
  .content {
    padding: 62px 20px 0 20px;
    background: #f5f7fa url(../../assets/images/login/bg.png) no-repeat left
      top/100% 331px;
  }
}
</style>
